/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';
import contentapi from '@/api/contentapi';

const namespace = 'content';

export default {
  namespace,
  state: Immutable({
    resourceTypeList: []
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    getResourceTypeList(payload) {
      return {
        type: namespace + '/update/getResourceTypeList',
        field: 'resourceTypeList',
        promise: contentapi.listType4Qr(payload)
      };
    }
  }
};
